module.exports = __webpack_public_path__ + "img/icon_sm_qyddj.777914a1.png";